/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as RoomsRouteImport } from './routes/rooms'
import { Route as ReportsRouteImport } from './routes/reports'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as BinRouteImport } from './routes/bin'
import { Route as AuditRouteImport } from './routes/audit'
import { Route as AgentRouteImport } from './routes/agent'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as RoomsIndexRouteImport } from './routes/rooms/index'
import { Route as SettingsUsersRouteImport } from './routes/settings/users'
import { Route as SettingsProfileRouteImport } from './routes/settings/profile'
import { Route as SettingsGroupsRouteImport } from './routes/settings/groups'
import { Route as SettingsAuditRouteImport } from './routes/settings/audit'
import { Route as SettingsAgentRouteImport } from './routes/settings/agent'
import { Route as RoomsNewRouteImport } from './routes/rooms/new'
import { Route as RoomsRoomIdRouteImport } from './routes/rooms/$roomId'
import { Route as AuthVerifyRouteImport } from './routes/auth/verify'
import { Route as RoomsRoomIdPermissionsRouteImport } from './routes/rooms/$roomId/permissions'
import { Route as InvitesInviteIdRedeemRouteImport } from './routes/invites/$inviteId/redeem'
import { Route as RoomsRoomIdFilesFileIdRouteImport } from './routes/rooms/$roomId/files/$fileId'

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const RoomsRoute = RoomsRouteImport.update({
  id: '/rooms',
  path: '/rooms',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsRoute = ReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const BinRoute = BinRouteImport.update({
  id: '/bin',
  path: '/bin',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditRoute = AuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentRoute = AgentRouteImport.update({
  id: '/agent',
  path: '/agent',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRoute,
} as any)
const RoomsIndexRoute = RoomsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RoomsRoute,
} as any)
const SettingsUsersRoute = SettingsUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsProfileRoute = SettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsGroupsRoute = SettingsGroupsRouteImport.update({
  id: '/groups',
  path: '/groups',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAuditRoute = SettingsAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAgentRoute = SettingsAgentRouteImport.update({
  id: '/agent',
  path: '/agent',
  getParentRoute: () => SettingsRoute,
} as any)
const RoomsNewRoute = RoomsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => RoomsRoute,
} as any)
const RoomsRoomIdRoute = RoomsRoomIdRouteImport.update({
  id: '/$roomId',
  path: '/$roomId',
  getParentRoute: () => RoomsRoute,
} as any)
const AuthVerifyRoute = AuthVerifyRouteImport.update({
  id: '/auth/verify',
  path: '/auth/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const RoomsRoomIdPermissionsRoute = RoomsRoomIdPermissionsRouteImport.update({
  id: '/permissions',
  path: '/permissions',
  getParentRoute: () => RoomsRoomIdRoute,
} as any)
const InvitesInviteIdRedeemRoute = InvitesInviteIdRedeemRouteImport.update({
  id: '/invites/$inviteId/redeem',
  path: '/invites/$inviteId/redeem',
  getParentRoute: () => rootRouteImport,
} as any)
const RoomsRoomIdFilesFileIdRoute = RoomsRoomIdFilesFileIdRouteImport.update({
  id: '/files/$fileId',
  path: '/files/$fileId',
  getParentRoute: () => RoomsRoomIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/agent': typeof AgentRoute
  '/audit': typeof AuditRoute
  '/bin': typeof BinRoute
  '/dashboard': typeof DashboardRoute
  '/login': typeof LoginRoute
  '/reports': typeof ReportsRoute
  '/rooms': typeof RoomsRouteWithChildren
  '/settings': typeof SettingsRouteWithChildren
  '/auth/verify': typeof AuthVerifyRoute
  '/rooms/$roomId': typeof RoomsRoomIdRouteWithChildren
  '/rooms/new': typeof RoomsNewRoute
  '/settings/agent': typeof SettingsAgentRoute
  '/settings/audit': typeof SettingsAuditRoute
  '/settings/groups': typeof SettingsGroupsRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/users': typeof SettingsUsersRoute
  '/rooms/': typeof RoomsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/invites/$inviteId/redeem': typeof InvitesInviteIdRedeemRoute
  '/rooms/$roomId/permissions': typeof RoomsRoomIdPermissionsRoute
  '/rooms/$roomId/files/$fileId': typeof RoomsRoomIdFilesFileIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/agent': typeof AgentRoute
  '/audit': typeof AuditRoute
  '/bin': typeof BinRoute
  '/dashboard': typeof DashboardRoute
  '/login': typeof LoginRoute
  '/reports': typeof ReportsRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/rooms/$roomId': typeof RoomsRoomIdRouteWithChildren
  '/rooms/new': typeof RoomsNewRoute
  '/settings/agent': typeof SettingsAgentRoute
  '/settings/audit': typeof SettingsAuditRoute
  '/settings/groups': typeof SettingsGroupsRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/users': typeof SettingsUsersRoute
  '/rooms': typeof RoomsIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/invites/$inviteId/redeem': typeof InvitesInviteIdRedeemRoute
  '/rooms/$roomId/permissions': typeof RoomsRoomIdPermissionsRoute
  '/rooms/$roomId/files/$fileId': typeof RoomsRoomIdFilesFileIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/agent': typeof AgentRoute
  '/audit': typeof AuditRoute
  '/bin': typeof BinRoute
  '/dashboard': typeof DashboardRoute
  '/login': typeof LoginRoute
  '/reports': typeof ReportsRoute
  '/rooms': typeof RoomsRouteWithChildren
  '/settings': typeof SettingsRouteWithChildren
  '/auth/verify': typeof AuthVerifyRoute
  '/rooms/$roomId': typeof RoomsRoomIdRouteWithChildren
  '/rooms/new': typeof RoomsNewRoute
  '/settings/agent': typeof SettingsAgentRoute
  '/settings/audit': typeof SettingsAuditRoute
  '/settings/groups': typeof SettingsGroupsRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/users': typeof SettingsUsersRoute
  '/rooms/': typeof RoomsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/invites/$inviteId/redeem': typeof InvitesInviteIdRedeemRoute
  '/rooms/$roomId/permissions': typeof RoomsRoomIdPermissionsRoute
  '/rooms/$roomId/files/$fileId': typeof RoomsRoomIdFilesFileIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/agent'
    | '/audit'
    | '/bin'
    | '/dashboard'
    | '/login'
    | '/reports'
    | '/rooms'
    | '/settings'
    | '/auth/verify'
    | '/rooms/$roomId'
    | '/rooms/new'
    | '/settings/agent'
    | '/settings/audit'
    | '/settings/groups'
    | '/settings/profile'
    | '/settings/users'
    | '/rooms/'
    | '/settings/'
    | '/invites/$inviteId/redeem'
    | '/rooms/$roomId/permissions'
    | '/rooms/$roomId/files/$fileId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/agent'
    | '/audit'
    | '/bin'
    | '/dashboard'
    | '/login'
    | '/reports'
    | '/auth/verify'
    | '/rooms/$roomId'
    | '/rooms/new'
    | '/settings/agent'
    | '/settings/audit'
    | '/settings/groups'
    | '/settings/profile'
    | '/settings/users'
    | '/rooms'
    | '/settings'
    | '/invites/$inviteId/redeem'
    | '/rooms/$roomId/permissions'
    | '/rooms/$roomId/files/$fileId'
  id:
    | '__root__'
    | '/'
    | '/agent'
    | '/audit'
    | '/bin'
    | '/dashboard'
    | '/login'
    | '/reports'
    | '/rooms'
    | '/settings'
    | '/auth/verify'
    | '/rooms/$roomId'
    | '/rooms/new'
    | '/settings/agent'
    | '/settings/audit'
    | '/settings/groups'
    | '/settings/profile'
    | '/settings/users'
    | '/rooms/'
    | '/settings/'
    | '/invites/$inviteId/redeem'
    | '/rooms/$roomId/permissions'
    | '/rooms/$roomId/files/$fileId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AgentRoute: typeof AgentRoute
  AuditRoute: typeof AuditRoute
  BinRoute: typeof BinRoute
  DashboardRoute: typeof DashboardRoute
  LoginRoute: typeof LoginRoute
  ReportsRoute: typeof ReportsRoute
  RoomsRoute: typeof RoomsRouteWithChildren
  SettingsRoute: typeof SettingsRouteWithChildren
  AuthVerifyRoute: typeof AuthVerifyRoute
  InvitesInviteIdRedeemRoute: typeof InvitesInviteIdRedeemRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rooms': {
      id: '/rooms'
      path: '/rooms'
      fullPath: '/rooms'
      preLoaderRoute: typeof RoomsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports': {
      id: '/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bin': {
      id: '/bin'
      path: '/bin'
      fullPath: '/bin'
      preLoaderRoute: typeof BinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit': {
      id: '/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent': {
      id: '/agent'
      path: '/agent'
      fullPath: '/agent'
      preLoaderRoute: typeof AgentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/rooms/': {
      id: '/rooms/'
      path: '/'
      fullPath: '/rooms/'
      preLoaderRoute: typeof RoomsIndexRouteImport
      parentRoute: typeof RoomsRoute
    }
    '/settings/users': {
      id: '/settings/users'
      path: '/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof SettingsUsersRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/profile': {
      id: '/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof SettingsProfileRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/groups': {
      id: '/settings/groups'
      path: '/groups'
      fullPath: '/settings/groups'
      preLoaderRoute: typeof SettingsGroupsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/audit': {
      id: '/settings/audit'
      path: '/audit'
      fullPath: '/settings/audit'
      preLoaderRoute: typeof SettingsAuditRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/agent': {
      id: '/settings/agent'
      path: '/agent'
      fullPath: '/settings/agent'
      preLoaderRoute: typeof SettingsAgentRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/rooms/new': {
      id: '/rooms/new'
      path: '/new'
      fullPath: '/rooms/new'
      preLoaderRoute: typeof RoomsNewRouteImport
      parentRoute: typeof RoomsRoute
    }
    '/rooms/$roomId': {
      id: '/rooms/$roomId'
      path: '/$roomId'
      fullPath: '/rooms/$roomId'
      preLoaderRoute: typeof RoomsRoomIdRouteImport
      parentRoute: typeof RoomsRoute
    }
    '/auth/verify': {
      id: '/auth/verify'
      path: '/auth/verify'
      fullPath: '/auth/verify'
      preLoaderRoute: typeof AuthVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rooms/$roomId/permissions': {
      id: '/rooms/$roomId/permissions'
      path: '/permissions'
      fullPath: '/rooms/$roomId/permissions'
      preLoaderRoute: typeof RoomsRoomIdPermissionsRouteImport
      parentRoute: typeof RoomsRoomIdRoute
    }
    '/invites/$inviteId/redeem': {
      id: '/invites/$inviteId/redeem'
      path: '/invites/$inviteId/redeem'
      fullPath: '/invites/$inviteId/redeem'
      preLoaderRoute: typeof InvitesInviteIdRedeemRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rooms/$roomId/files/$fileId': {
      id: '/rooms/$roomId/files/$fileId'
      path: '/files/$fileId'
      fullPath: '/rooms/$roomId/files/$fileId'
      preLoaderRoute: typeof RoomsRoomIdFilesFileIdRouteImport
      parentRoute: typeof RoomsRoomIdRoute
    }
  }
}

interface RoomsRoomIdRouteChildren {
  RoomsRoomIdPermissionsRoute: typeof RoomsRoomIdPermissionsRoute
  RoomsRoomIdFilesFileIdRoute: typeof RoomsRoomIdFilesFileIdRoute
}

const RoomsRoomIdRouteChildren: RoomsRoomIdRouteChildren = {
  RoomsRoomIdPermissionsRoute: RoomsRoomIdPermissionsRoute,
  RoomsRoomIdFilesFileIdRoute: RoomsRoomIdFilesFileIdRoute,
}

const RoomsRoomIdRouteWithChildren = RoomsRoomIdRoute._addFileChildren(
  RoomsRoomIdRouteChildren,
)

interface RoomsRouteChildren {
  RoomsRoomIdRoute: typeof RoomsRoomIdRouteWithChildren
  RoomsNewRoute: typeof RoomsNewRoute
  RoomsIndexRoute: typeof RoomsIndexRoute
}

const RoomsRouteChildren: RoomsRouteChildren = {
  RoomsRoomIdRoute: RoomsRoomIdRouteWithChildren,
  RoomsNewRoute: RoomsNewRoute,
  RoomsIndexRoute: RoomsIndexRoute,
}

const RoomsRouteWithChildren = RoomsRoute._addFileChildren(RoomsRouteChildren)

interface SettingsRouteChildren {
  SettingsAgentRoute: typeof SettingsAgentRoute
  SettingsAuditRoute: typeof SettingsAuditRoute
  SettingsGroupsRoute: typeof SettingsGroupsRoute
  SettingsProfileRoute: typeof SettingsProfileRoute
  SettingsUsersRoute: typeof SettingsUsersRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsAgentRoute: SettingsAgentRoute,
  SettingsAuditRoute: SettingsAuditRoute,
  SettingsGroupsRoute: SettingsGroupsRoute,
  SettingsProfileRoute: SettingsProfileRoute,
  SettingsUsersRoute: SettingsUsersRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AgentRoute: AgentRoute,
  AuditRoute: AuditRoute,
  BinRoute: BinRoute,
  DashboardRoute: DashboardRoute,
  LoginRoute: LoginRoute,
  ReportsRoute: ReportsRoute,
  RoomsRoute: RoomsRouteWithChildren,
  SettingsRoute: SettingsRouteWithChildren,
  AuthVerifyRoute: AuthVerifyRoute,
  InvitesInviteIdRedeemRoute: InvitesInviteIdRedeemRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
